/** MediaRecorder mime fallback for Chrome (webm) and iOS Safari (mp4/AAC). */

export const VOICE_RECORDER_MIME_CANDIDATES = [
  'audio/webm;codecs=opus',
  'audio/webm',
  'audio/mp4',
  'audio/aac',
] as const;

export function isVoiceRecordingSupported(): boolean {
  return typeof MediaRecorder !== 'undefined';
}

/** First supported type, or '' to use the unspecified MediaRecorder default. */
export function pickSupportedRecorderMime(
  isTypeSupported: (mime: string) => boolean = (mime) =>
    typeof MediaRecorder !== 'undefined' && MediaRecorder.isTypeSupported(mime)
): string {
  for (const mime of VOICE_RECORDER_MIME_CANDIDATES) {
    try {
      if (isTypeSupported(mime)) return mime;
    } catch {
      // Some browsers throw on unknown types.
    }
  }
  return '';
}

export function recordedVoiceFilename(file: Blob): string {
  if (file instanceof File && file.name) return file.name;
  const t = (file.type || '').toLowerCase();
  if (t.includes('wav')) return 'voice-recorded.wav';
  if (t.includes('mp4') || t.includes('m4a')) return 'voice-recorded.m4a';
  if (t.includes('aac')) return 'voice-recorded.aac';
  if (t.includes('webm')) return 'voice-recorded.webm';
  return 'voice-recorded.webm';
}
